import {
  LOGIN_PATTERN,
  MAX_LOGIN_LENGTH,
  MIN_LOGIN_LENGTH,
  MIN_PASSWORD_LENGTH,
} from '../../../shared/lib/constants';

export interface FieldErrors {
  login?: string;
  password?: string;
  invite_code?: string;
  confirm_password?: string;
}

export function validateLogin(value: string): string | null {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return 'Укажите логин';
  }
  if (trimmed.length < MIN_LOGIN_LENGTH) {
    return `Логин должен содержать не менее ${MIN_LOGIN_LENGTH} символов`;
  }
  if (trimmed.length > MAX_LOGIN_LENGTH) {
    return `Логин не длиннее ${MAX_LOGIN_LENGTH} символов`;
  }
  if (!LOGIN_PATTERN.test(trimmed)) {
    return 'Логин: только латинские буквы, цифры, дефис и подчёркивание';
  }
  return null;
}

export function validatePassword(value: string): string | null {
  if (value.length === 0) {
    return 'Укажите пароль';
  }
  if (value.length < MIN_PASSWORD_LENGTH) {
    return `Пароль должен содержать не менее ${MIN_PASSWORD_LENGTH} символов`;
  }
  return null;
}

export function validateInviteCode(value: string): string | null {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return 'Укажите код приглашения';
  }
  return null;
}

export function validateLoginForm(values: {
  login: string;
  password: string;
}): FieldErrors {
  const errors: FieldErrors = {};
  const loginError = validateLogin(values.login);
  if (loginError !== null) {
    errors.login = loginError;
  }
  const passwordError = validatePassword(values.password);
  if (passwordError !== null) {
    errors.password = passwordError;
  }
  return errors;
}

export function validateRegisterForm(values: {
  login: string;
  password: string;
  confirm_password: string;
  invite_code: string;
}): FieldErrors {
  const errors: FieldErrors = {};
  const loginError = validateLogin(values.login);
  if (loginError !== null) {
    errors.login = loginError;
  }
  const passwordError = validatePassword(values.password);
  if (passwordError !== null) {
    errors.password = passwordError;
  }
  if (values.confirm_password !== values.password) {
    errors.confirm_password = 'Пароли не совпадают';
  }
  const inviteError = validateInviteCode(values.invite_code);
  if (inviteError !== null) {
    errors.invite_code = inviteError;
  }
  return errors;
}

export function hasFieldErrors(errors: FieldErrors): boolean {
  return Object.keys(errors).length > 0;
}
